import { useRef } from 'react';
import { SnackbarProvider as NotistackProvider, closeSnackbar } from 'notistack';
// @mui
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
//
import Iconify from '../iconify';
import SvgColor from '../svg-color';
import { useSettingsContext } from '../settings';
//
import { StyledIcon, StyledNotistack } from './styles';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function SnackbarProvider({ children }: Props) {
  const settings = useSettingsContext();

  const isRTL = settings.themeDirection === 'rtl';

  const notistackRef = useRef<any>(null);

  return (
    <NotistackProvider
      ref={notistackRef}
      maxSnack={5}
      preventDuplicate
      autoHideDuration={4000}
      TransitionComponent={isRTL ? Collapse : undefined}
      variant="info" // Set default variant
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      iconVariant={{
        info: (
          <StyledIcon color="info">
            <SvgColor
              src="/assets/icons/global/eva--info-fill.svg"
              sx={{ width: 24, height: 24 }}
            />
          </StyledIcon>
        ),
        success: (
          <StyledIcon color="success">
            <SvgColor
              src="/assets/icons/global/eva--checkmark-circle-2-fill.svg"
              sx={{ width: 24, height: 24 }}
            />
          </StyledIcon>
        ),
        warning: (
          <StyledIcon color="warning">
            <SvgColor
              src="/assets/icons/global/eva--alert-triangle-fill.svg"
              sx={{ width: 24, height: 24 }}
            />
          </StyledIcon>
        ),
        error: (
          <StyledIcon color="error">
            <SvgColor
              src="/assets/icons/global/solar--danger-bold.svg"
              sx={{ width: 24, height: 24 }}
            />
          </StyledIcon>
        ),
      }}
      Components={{
        default: StyledNotistack,
        info: StyledNotistack,
        success: StyledNotistack,
        warning: StyledNotistack,
        error: StyledNotistack,
      }}
      // with close as default
      action={(snackbarId) => (
        <IconButton
          size="small"
          onClick={() => closeSnackbar(snackbarId)}
          sx={(theme) => ({
            p: 1,
            marginLeft: 4,
            marginRight: theme.direction === 'ltr' ? 0 : -2,
          })}
        >
          <SvgColor
            src="/assets/icons/global/mingcute--close-line.svg"
            sx={{ width: 16, height: 16 }}
          />
          {/* <Iconify width={16} icon="mingcute:close-line" /> */}
        </IconButton>
      )}
    >
      {children}
    </NotistackProvider>
  );
}
